import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuditVisitationService {

  constructor(private httpClient: HttpClient) { }


  async getAudits(){
    return new Promise((resolve, reject) => {    
      try{
        this.httpClient.get<any>(`https://us-central1-bwi-audit-dev.cloudfunctions.net/getAllAudits`, {}).subscribe(data => {
          console.log(data);
          resolve(data)
        });     
        
      }catch(err){
        console.log(err);
        reject(err);
      }
    })
    
    }


}
